export enum NotificationKeyValue {
  userNotification = "User Notification",
  applicationNotification = "Application Notification",
  jobNotification = "Job Notification",
  licenseNotification = "License Notification",
  nodeUsageNotifications = "Node Usage Notification",
  walletNotifications = "Wallet Notification",
  deploymentNotifications = "Deployment Action Notification",
  sessionNotifications = "Session Notifications",
  storageNotifications = "Storage Notifications"
}

export enum UserNotifyActions {
  addUser = "New User Added",
  updateUser = "User Updated",
  deleteUser = "User Deleted"
}

export enum ApplicationNotifyActions {
  addApplication = "Add New Application",
  updateApplication = "Update Application",
  deleteApplication = "Deleted Application"
}

export enum DeploymentNotifyActions {
  deploymentAdded = "Deployment Added",
  deploymentSettingsUpdated = "Deployment Settings Update",
  deploymentDeleted = "Deployment Deleted"
}

export enum JobNotifyActions {
  jobSubmit = "New Job Submitted",
  jobSuccess = "Job Completed",
  jobFailed = "Job Failed",
  jobCancelled = "Job Cancelled",
  jobContactSupport = "Job Contact Support",
}

export enum LicenseNotifyActions {
  licenseConnectivity = "License Connectivity"
}

export enum NodeUsageNotifyActions {
  nodeUtilizationThresholds = "Node Utilization Thresholds",
  nodeUsageDailyReport = "Node Usage Daily Report"
}

export enum SessionNotifyActions {
  idleUser = "Idle User",
  multipleUserSessions = "Multiple User Sessions",
  sessionConnect = "Session Connect",
  sessionRemove = "Session Remove",
  sessionReady = "Session Ready",
  sessionExpiring = "Session Expiring",
  sessionRequested = "Session Requested"
}

export enum StorageNotifyActions {
  syncStoreAlert = "SyncStore Alert",
  syncStoreFullAlert = "SyncStore Full Alert",
  workStoreAlert = "WorkStore Alert",
  workStoreFullAlert = "WorkStore Full Alert"
}

export enum WalletNotifyActions {
  walletRecharged = "Wallet Recharged",
  walletAlert = "Wallet Balance Alert",
  walletBalanceEmpty = "Wallet Empty",
  walletUpdate = "Wallet Update"
}


export class ApplicationNotifications {
  AddApplication: boolean;
  UpdateApplication: boolean;
  DeleteApplication: boolean;
  DuplicateApplication: boolean;
}

export class DeploymentNotifications {
  DeploymentAdded: boolean;
  DeploymentSettingsUpdated: boolean;
  DeploymentDeleted: boolean;
}

export class JobNotifications {
  JobSubmit: boolean;
  JobSuccess: boolean;
  JobFailed: boolean;
  JobCancelled: boolean;
  JobContactSupport: boolean;
}

export class LicenseNotification {
  LicenseConnectivity: boolean;
}

export class NodeUsageNotifications {
  NodeUtilizationThresholds: boolean;
  NodeUsageDailyReport: boolean;
}

export class SessionNotifications {
  IdleUser: boolean;
  MultipleUserSessions: boolean;
  SessionConnect: boolean;
  SessionRemove: boolean;
  SessionReady: boolean;
  SessionExpiring: boolean;
  SessionRequested: boolean;
}

export class StorageNotifications {
  SyncStoreAlert: boolean;
  SyncStoreFullAlert: boolean;
  WorkStoreAlert: boolean;
  WorkStoreFullAlert: boolean;
}

export class UserNotifications {
  AddUser: boolean;
  UpdateUser: boolean;
  DeleteUser: boolean;
}

export class WalletNotifications {
  WalletRecharged: boolean;
  WalletAlert: boolean;
  WalletBalanceEmpty: boolean;
  WalletUpdate: boolean;
}

export class Notifications {
  userNotification: UserNotifications;
  applicationNotification: ApplicationNotifications;
  jobNotifications: JobNotifications;
  walletNotifications: WalletNotifications;
}

export class NotificationTypes {
  EmailNotifications: Notifications;
  PortalNotifications: Notifications;
  SMSNotifications: Notifications;
}

export class MappingUtility {
  static keyToPropertyMap: Record<string, keyof UserNotifications> = {
    addUser: 'AddUser',
    updateUser: 'UpdateUser',
    deleteUser: 'DeleteUser'
  };
}

export const actionEnums: Record<string, Record<string, string>> = {
  [NotificationKeyValue.userNotification]: UserNotifyActions,
  [NotificationKeyValue.applicationNotification]: ApplicationNotifyActions,
  [NotificationKeyValue.jobNotification]: JobNotifyActions,
  [NotificationKeyValue.nodeUsageNotifications]: NodeUsageNotifyActions,
  [NotificationKeyValue.licenseNotification]: LicenseNotifyActions,
  [NotificationKeyValue.walletNotifications]: WalletNotifyActions,
  [NotificationKeyValue.deploymentNotifications]: DeploymentNotifyActions,
  [NotificationKeyValue.sessionNotifications]: SessionNotifyActions,
  [NotificationKeyValue.storageNotifications]: StorageNotifyActions,
};

export function getNotificationActions(input: string): { key: string; value: string }[] {
  const selectedEnum = actionEnums[input];
  if (!selectedEnum) {
    return [];
  }

  const actionsArray = Object.entries(selectedEnum).map(([key, value]) => ({ key, value }));
  return actionsArray;
}
